import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomCssTextField = styled(TextField)(({ theme }) => ({
    '& label.Mui-focused': {
        color: theme.palette.cmpPrimary.main,
    },
    '& label.MuiFormLabel-filled': {
        // background: '#00709B',
        color: theme.palette.blue.main,
        padding: '0 2px',
    },
    '& label': {
        color: theme.palette.gray.graniteGray,
        fontSize: '14px',
        fontWeight: '400',
        fontFamily: theme.typography.fontFamily,
    },
    '& .MuiInputBase-input': {
        color: theme.palette.gray.graniteGray,
        fontSize: '14px',
        fontWeight: '400',
        fontFamily: theme.typography.fontFamily,
        background: '#FFFFFF',
        borderRadius: '4px',
        '&.Mui-disabled': {
            background: 'transparent',
        },
    },
    //  '& .MuiInputBase-sizeSmall': { background: '#FFFFFF' },
    '& .MuiOutlinedInput-root': {
        background: '#FFFFFF',
        '& fieldset': {
            color: theme.palette.textColors.$color_text_tertiary,
            borderColor: theme.palette.border.$color_border_input,
        },
        '&:hover fieldset': {
            borderColor: theme.palette.border.$color_border_input_hover,
        },
        '&.Mui-focused fieldset': {
            color: theme.palette.textColors.$color_text_primary,
            border: `2px solid ${theme.palette.border.$color_border_input_focus}`,
        },
    },
    '& .MuiInputLabel-root': {
        transform: 'translate(14px, 10px) scale(1)',
    },
    '& .MuiInputLabel-shrink': {
        transform: 'translate(14px, -8px)',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        fontFamily: theme.typography.fontFamily,
    },
    '& legend': {
        fontSize: '12px !important',
        fontWeight: '500 !important',
        fontFamily: theme.typography.fontFamily,
    },
    '& .Mui-disabled': {
        color: theme.palette.gray.graniteGray,
        backgroundColor: '#f4f4f4',
    },
}));

export default CustomCssTextField;
